import { render } from "./PaymentServices.vue?vue&type=template&id=12b4ac8a"
import script from "./PaymentServices.vue?vue&type=script&lang=js"
export * from "./PaymentServices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__